import { render } from "./storage-settings.vue?vue&type=template&id=4834d3f9"
import script from "./storage-settings.vue?vue&type=script&lang=js"
export * from "./storage-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__